/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

window.Vue = require("vue");
window.Swal = require('sweetalert2');
window.fileDownload = require('js-file-download');

import {
    BootstrapVue,
    IconsPlugin
} from "bootstrap-vue";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

Vue.use(require("vue-moment"));
Vue.prototype.trans = (string, args) => {
    let value = _.get(window.i18n, string);

    _.eachRight(args, (paramVal, paramKey) => {
        value = _.replace(value, `:${paramKey}`, paramVal);
    });
    return value;
};

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context("./", true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        key
        .split("/")
        .pop()
        .split(".")[0],
        files(key).default
    )
);

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Vue Loading Overlay Declaration
 */
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
const optionsLoading = {
    color: "blue",
    opacity: 0.5,
    "background-color": "#000000",
    zIndex: 2000
};
Vue.use(Loading, optionsLoading);

Vue.mixin({
    methods: {
        route: route,
        errorPopup: function (message) {
            this.$swal({
                icon: "error",
                title: "Error",
                text: message,
            });
        },
        successSwal: function () {
            this.$swal({
                icon: "success",
                showConfirmButton: false,
                timer: 1500
            });
        }
    }
});

$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.app = new Vue({
    el: "#app"
});
